import React from "react";

import { ChartContainer } from "../../containers/ChartContainer/ChartContainer";
import { ChartHeaderLayout } from "../../layouts/ChartHeaderLayout/ChartHeaderLayout";

const ChartPage = () => {
  return (
    <ChartHeaderLayout chart="true" chartDetail={false}>
      <ChartContainer />
    </ChartHeaderLayout>
  );
};

export default ChartPage;
